"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../../../../Button/Button"));
var _BasicInputRow = _interopRequireDefault(require("../../../../Form/BasicInputRow"));
var _Svg = _interopRequireDefault(require("../../../../Svg/Svg"));
var _constants = require("../../../../constants");
var SignUp = function SignUp(_ref) {
  var heading = _ref.heading,
    subheading = _ref.subheading,
    whiteFont = _ref.whiteFont,
    link = _ref.link,
    on = _ref.on,
    expandable = _ref.expandable,
    size = _ref.size,
    signUp = _ref.signUp,
    addressBookId = _ref.addressBookId,
    text = _ref.text,
    hideLastName = _ref.hideLastName;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-relative image--banner flex flex-column flex-center height-100% ".concat(size)
  }, subheading && /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('text-sm', 'banner--subheading', 'd8-u-text-uppercase', 'd8-u-ls-sm', whiteFont && 'd8-u-color-white')
  }, subheading), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component text-center expandable-animation max-width-md width-100%"
  }, heading && /*#__PURE__*/_react["default"].createElement("h2", {
    className: (0, _classnames["default"])('card--image__heading', 'd8-u-ls-sm', 'text-xxl', whiteFont && 'd8-u-color-white')
  }, heading), link && /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-md"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    link: link.url,
    external: link.external,
    text: link.text,
    buttonType: _constants.BUTTON_TYPES.BARE_WHITE,
    icon: "arrow-right",
    iconFlip: true
  })), expandable && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-column flex-center width-100% margin-top-md"
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    className: "icon--sm",
    name: "arrow-down"
  }))), text && /*#__PURE__*/_react["default"].createElement("p", {
    className: "d8-u-color-white margin-bottom-md max-width-xs"
  }, text), signUp && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_BasicInputRow["default"], {
    hideLastName: hideLastName,
    postTo: "/api/marketing/add-contact",
    extraBodyProps: {
      addressBookId: addressBookId
    },
    successMessage: "You're signed up!"
  })), on && /*#__PURE__*/_react["default"].createElement("span", {
    className: "expandable-close"
  }, /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
    className: "icon--xs",
    name: "arrow-up"
  })));
};
SignUp.propTypes = {
  heading: _propTypes["default"].string,
  subheading: _propTypes["default"].string,
  size: _propTypes["default"].string,
  text: _propTypes["default"].string,
  whiteFont: _propTypes["default"].bool,
  on: _propTypes["default"].bool,
  expandable: _propTypes["default"].bool,
  signUp: _propTypes["default"].bool,
  hideLastName: _propTypes["default"].bool,
  addressBookId: _propTypes["default"].string,
  link: _propTypes["default"].object
};
SignUp.defaultProps = {
  size: 'xs'
};
var _default = exports["default"] = SignUp;